module.exports = __webpack_public_path__ + "assets/models/DefaultAvatar-798e20921f79aae310651e2fcb6f6ebb.glb";